<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && languages">
			<title-bar title="Idiomas" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="row between innerRubric" >
				<b-table class="category all" striped hover :items="languages" :fields="tableFields">
					<template slot="actions" slot-scope="item">
						<b-button size="lg" class="more" @click="goToRoute(item)">
							Ver más
						</b-button>
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				name: {
					label: 'Idioma',
					sortable: true
				},
				average: {
					label: 'Promedio',
					sortable: true
				},
				category1: {
					label: 'Ambiente emocional',
					sortable: true
				},
				category2: {
					label: 'Proceso académico',
					sortable: true
				},
				category3: {
					label: 'Aprendizaje profundo',
					sortable: true
				},
				category4: {
					label: 'Aprendizaje experto',
					sortable: true
				},
				actions: {
					label: '',
					sortable: false
				}
			}
		};
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else this.$store.state.school.summary;
		},
		languages () {
			if (this.$store.state.languages.summary) return this.$store.state.languages.summary.map((item) => {
				item.name = item.itemName;
				item.average = `${parseInt(item.itemPercentage)}%`;
				let category1 = item.coachingCategories.find((category) => {return category.id == 1;});
				let category2 = item.coachingCategories.find((category) => {return category.id == 2;});
				let category3 = item.coachingCategories.find((category) => {return category.id == 3;});
				let category4 = item.coachingCategories.find((category) => {return category.id == 4;});
				item.category1 = `${parseInt(category1.percentage)}%`;
				item.category2 = `${parseInt(category2.percentage)}%`;
				item.category3 = `${parseInt(category3.percentage)}%`;
				item.category4 = `${parseInt(category4.percentage)}%`;
				return item;
			});
			else return [];
		}
	},
	methods: {
		goToRoute (item) {
			this.$router.push('/coaching/languages/summary/' + item.item.itemId);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/languages/List.vue